import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { AuthCard } from './AuthLayout';
const content = {
    terms: {
        title: 'Terms of Service',
        subtitle: 'The basics of using tween.studio.',
        sections: [
            {
                heading: 'Using the service',
                body: 'By creating an account or using tween.studio you agree to use the product lawfully and respectfully. You are responsible for content you create and for keeping your credentials secure.',
            },
            {
                heading: 'Accounts',
                body: 'We may suspend accounts that abuse the platform, attempt unauthorized access, or violate these terms.',
            },
            {
                heading: 'Changes',
                body: 'We may update these terms as the product evolves. Continued use after changes means you accept the updated terms. This page is a living draft and will be refined as we ship.',
            },
        ],
    },
    privacy: {
        title: 'Privacy Policy',
        subtitle: 'How we handle your information.',
        sections: [
            {
                heading: 'What we collect',
                body: 'We collect account details you provide (such as name and email), authentication data, and usage needed to run the editor and keep your projects available.',
            },
            {
                heading: 'How we use it',
                body: 'Data is used to authenticate you, store projects, improve the product, and communicate service-related updates. We do not sell your personal information.',
            },
            {
                heading: 'Cookies',
                body: 'Essential cookies keep you signed in and secure the session. Optional cookies help us understand product usage. You can choose Essential only or Accept all from the cookie banner; your choice is stored locally in your browser.',
            },
            {
                heading: 'Your choices',
                body: 'You can update profile details from the app and request account deletion by contacting support. Third-party sign-in providers process data under their own policies.',
            },
        ],
    },
};
export function TermsOfService() {
    return _jsx(LegalDocument, { page: "terms" });
}
export function PrivacyPolicy() {
    return _jsx(LegalDocument, { page: "privacy" });
}
function LegalDocument({ page }) {
    const doc = content[page];
    return (_jsx(AuthCard, { title: doc.title, subtitle: doc.subtitle, children: _jsxs("div", { className: "auth-legal-doc", children: [doc.sections.map((section) => (_jsxs("section", { className: "auth-legal-section", children: [_jsx("h3", { children: section.heading }), _jsx("p", { children: section.body })] }, section.heading))), _jsx("div", { className: "auth-footer", children: _jsx(Link, { to: "/login", className: "auth-link", children: "Back to sign in" }) })] }) }));
}
